/**
 * Calls that can run long (the AI), the background filer's status and client upload links (they share
 * the filing service's site access and secret): sent to our own Functions app when there is one.
 */
const AI_ROUTES: RegExp = /^(filing\/read|background\/[^/]+|uploads\/.+|public\/upload\/.+)$/;

/** How long to wait for an answer: the AI calls can legitimately take a few minutes; nothing else should. */
export function apiTimeoutMs(path: string): number {
  return AI_ROUTES.test(path) ? 240000 : 30000;
}

export function apiUrl(path: string, base: string): string {
  return base && AI_ROUTES.test(path) ? `${base}/${path}` : `/api/${path}`;
}
